export default "__VITE_ASSET__2C22_94r__"